const header = {
    home: 'Home',
    about: 'About',
    projects: 'Projects',
    contacts: 'Contact',
    resume: 'Résumé',
    switchLanguage: 'Switch language',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    skipToContent: 'Skip to content',
};

export default header;
